var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.027,
    height: 19.811,
    viewBox: "0 0 119.027 19.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aeon-blanc_casse\\u0301",
    "data-name": "aeon-blanc casse\\u0301",
    transform: "translate(-268.473 -234.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M295.5,254.22l-10.812-19.135a.374.374,0,0,0-.355-.2h-4.646a.374.374,0,0,0-.355.2L268.514,254.22c-.1.217-.02.355.217.355h3.782a.374.374,0,0,0,.355-.2l9.058-16.1a.09.09,0,0,1,.158,0l9.05,16.1a.374.374,0,0,0,.355.2h3.782C295.515,254.575,295.594,254.437,295.5,254.22Z",
    transform: "translate(0 -0.063)",
    fill: "#1e1c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M407.264,250.917h-24.3a.315.315,0,0,0-.312.315v3.005a.281.281,0,0,0,.3.281h24.319a.281.281,0,0,0,.3-.281v-3.014a.281.281,0,0,0-.3-.307Zm0-16.088H382.945a.281.281,0,0,0-.3.281v3a.312.312,0,0,0,.312.312h24.3a.281.281,0,0,0,.3-.3v-2.989a.281.281,0,0,0-.3-.3Z",
    transform: "translate(-82.047 -0.021)",
    fill: "#1e1c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M407.56,263.645v3.014a.281.281,0,0,1-.3.3h-24.3a.312.312,0,0,1-.312-.312v-2.977a.315.315,0,0,1,.312-.315h24.3a.281.281,0,0,1,.3.3Z",
    transform: "translate(-82.047 -20.515)",
    fill: "#1e1c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M515.882,244.095a8.487,8.487,0,0,0-4.2-7.089,17.842,17.842,0,0,0-8.78-2.206h-.591a17.708,17.708,0,0,0-8.805,2.206,8.49,8.49,0,0,0-4.176,7.089,5.011,5.011,0,0,0-.02.611v.039a5.017,5.017,0,0,0,.02.611,8.54,8.54,0,0,0,4.176,7.089,17.653,17.653,0,0,0,8.805,2.167h.591a17.769,17.769,0,0,0,8.78-2.167,8.537,8.537,0,0,0,4.2-7.089,5,5,0,0,0,.02-.611v-.039A5,5,0,0,0,515.882,244.095Zm-6.99,5.375a13.507,13.507,0,0,1-6.005,1.427h-.563a13.662,13.662,0,0,1-6.03-1.438,5.215,5.215,0,0,1,0-9.489,13.417,13.417,0,0,1,6.042-1.455h.563a13.257,13.257,0,0,1,6.005,1.458,5.2,5.2,0,0,1-.011,9.5Z",
    transform: "translate(-158.695)",
    fill: "#1e1c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M626.893,234.832h-3.346a.262.262,0,0,0-.3.281v14.276l-17.166-14.433a.521.521,0,0,0-.374-.138h-3.433a.262.262,0,0,0-.281.281v19.13a.259.259,0,0,0,.281.281h3.346a.259.259,0,0,0,.3-.281V239.652l17.166,14.729a.529.529,0,0,0,.374.135h3.425a.259.259,0,0,0,.281-.281V235.128a.262.262,0,0,0-.273-.3Z",
    transform: "translate(-239.669 -0.012)",
    fill: "#1e1c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.3f44c78398d8430ea756ccca976d6f60.svg";
export { ForwardRef as ReactComponent };